import Intercom from '@intercom/messenger-js-sdk';
import config from '@/config/widgets';
import { request } from '@/api/request';
import type { TrialResponse } from '@/modules/trial/api';
import type AnalyticsModule from './analyticsModule';

const getIntercomJWT = () => request<{ jwt: string }>('GET', '/user/intercom/jwt');

const setUserData = async (user: any) => {
  if (user && window.intercomSettings) {
    window.intercomSettings.user_id = user.userID;
    window.intercomSettings.name = `${user.firstName} ${user.lastName}`;
    window.intercomSettings.phone = user.phone;
    window.intercomSettings.email = user.email;

    window.intercomSettings.createdAt = user.createdAt;
    window.intercomSettings.activatedAt = user.activatedAt;
    window.intercomSettings.status = user.status;
    window.intercomSettings.role = user.role;
    window.intercomSettings.team = user.team;

    window.intercomSettings.godUser = `${config.appUrl}/zeus/users/${user.userID}`;

    const { data } = await getIntercomJWT();
    Intercom({
      app_id: config.intercomAppID,
      api_base: 'https://api-iam.eu.intercom.io',
      region: 'eu',
      user_id: user.userID,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      created_at: user.createdAt,
      intercom_user_jwt: data.jwt,
    });
  }
};

const setOrgData = (org: any, status: any, trial?: TrialResponse) => {
  if (org && window.intercomSettings) {
    window.intercomSettings.company = {
      name: org.name,
      company_id: org.orgID,
      website: org.website,
      isSupplier: org.isSupplier,
      isClient: org.isClient,
      paid: org.paid,
      assessmentProgress: status ? status.assessmentProgress : '',
      initialAssessmentComplete: status ? status.initialAssessmentComplete : '',
      scopingComplete: status ? status.scopingComplete : '',
      trialType: trial ? trial.trialType : '',
    };

    window.intercomSettings.avatar = {
      type: 'avatar',
      image_url: org.logoUrl,
    };
  }
};

/* eslint class-methods-use-this: 0 */
export default class implements AnalyticsModule {
  constructor() {
    window.intercomSettings = {
      app_id: config.intercomAppID,
      api_base: 'https://api-iam.eu.intercom.io',
    };
    Intercom({
      app_id: config.intercomAppID,
      region: 'eu',
    });
  }

  trackEvent(eventName: string, metaObject: Record<string, any>) {
    window.Intercom('trackEvent', eventName, metaObject);
  }

  trackView() {
    window.Intercom('update');
  }

  async setUserProperties(params: any) {
    const { user, org, status, trial } = params;
    await setUserData(user);
    setOrgData(org, status, trial);
    window.Intercom('update', window.intercomSettings);
  }
}
